/**
 * Created by 高春超 on 2018/1/30.
 * 购物车
 */
import { post, post2 } from 'utils/post';
/*
 购物车列表
 */
export function getCartList(data) {
  return post('/api/cart/cart_list', data)
}
// 获取订单信息
export function getPayMent(data) {
  return post2('/api/order/getOrderPayInfo', data)
}



// WEBPACK FOOTER //
// ./src/api/cart.js